import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./ui/global.css";
import "./styles/goldsmith.css";
import "./styles/vault-ref.css"; // 1:1 reference "SERENE GLASS" stylesheet (vault-app), wins over goldsmith
import { App } from "./App";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
